<template>
  <div>
    <BuilderWrapper
      title="Sunburst Settings"
    >
      <LabelledInput label="Maximum number of rings to display">
        <b-radio-group
          v-model="maximum"
          :options="[1,2,3]"
          buttons
          button-variant="outline-primary"
          class="btn-block"
        />
      </LabelledInput>
    </BuilderWrapper>

    <ScaleFactorSettings />

    <FieldSettings />
  </div>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import LabelledInput from '@/components/builder/UI/LabelledInput.vue'
import BuilderWrapper from '@/components/builder/UI/BuilderWrapper.vue'
import FieldSettings from '@/components/builder/FieldSettings/FieldSettings.vue'
import ScaleFactorSettings from '@/components/builder/ScaleFactorSettings.vue'
import BetaBadge from '@/components/builder/UI/BetaBadge.vue'
import { SUNBURST_CONFIG_KEY } from '@/constants'

const components = {
  BuilderWrapper,
  FieldSettings,
  BetaBadge,
  LabelledInput,
  ScaleFactorSettings,
}

// eslint-disable-next-line no-use-before-define
@Component<SunburstSettingsView>({
  components,
})
export default class SunburstSettingsView extends Vue {
  async mounted () {
    await this.$typedStore.public.display.activateInitialTab(true)
  }

  get maximum () {
    return this.$typedStore.primary.app.config.sunburst.max
  }

  set maximum (value) {
    this.$typedStore.primary.app.updateConfig({ configPath: [SUNBURST_CONFIG_KEY, 'max'], value })
  }
}

</script>
